import React from "react";
import "./cornersButton.css";
import Button from "../button";
import classNames from "classnames";

const CornersButton = (props) => {
  const { onClick, left, children } = props;
  return (
    <div className={classNames("cornersButton", { " left": left })}>
      <Button onClick={onClick} className="btn">
        {children}
      </Button>
    </div>
  );
};

export default CornersButton;
